// « Mon premier départ » — livret pédagogique CodeVoiture.fr × Code2Roues.fr
// Structure réutilisable : les futurs dossiers s'ajoutent sans refonte.
import { DOSSIER_02 } from './premierDepartDossier02';
import { DOSSIER_03 } from './premierDepartDossier03';
import { DOSSIER_04 } from './premierDepartDossier04';
import { DOSSIER_05 } from './premierDepartDossier05';
import { DOSSIER_06 } from './premierDepartDossier06';
import { DOSSIER_07 } from './premierDepartDossier07';
import { DOSSIER_08 } from './premierDepartDossier08';
import { DOSSIER_09 } from './premierDepartDossier09';
import { DOSSIER_10 } from './premierDepartDossier10';
import { DOSSIER_11 } from './premierDepartDossier11';
import { DOSSIER_12 } from './premierDepartDossier12';
import { DOSSIER_13 } from './premierDepartDossier13';
import { DOSSIER_14 } from './premierDepartDossier14';
import { DOSSIER_15 } from './premierDepartDossier15';
import { DOSSIER_16 } from './premierDepartDossier16';
import { DOSSIER_17 } from './premierDepartDossier17';

export const MPD_META = {
  title: 'Mon premier départ',
  tagline: 'Les premiers pas vers la conduite, dès 14 ans',
  cobrand: 'Un livret pédagogique CodeVoiture.fr × Code2Roues.fr',
  updatedAt: '19 juin 2026',
  heroImage: 'https://static.prod-images.emergentagent.com/jobs/c292cde0-62e6-4d67-8d5e-ce29527d25c3/images/3111d5d28cd951c68d2a2bb68310ca4f7a47ba19489a80a08e77146fb1987168.jpeg',
};

const IMG = {
  ch1: 'https://static.prod-images.emergentagent.com/jobs/c292cde0-62e6-4d67-8d5e-ce29527d25c3/images/ed86d7ae6b177edb948f91ec208c03fb30e4d3a08b93a3cf27488289ed6c8da9.jpeg',
  ch2: 'https://static.prod-images.emergentagent.com/jobs/c292cde0-62e6-4d67-8d5e-ce29527d25c3/images/e1a34c14d4acb8e3ea0f43836ac57021ccb04baf858814724faf91d9eadb13d3.jpeg',
  ch3: 'https://static.prod-images.emergentagent.com/jobs/c292cde0-62e6-4d67-8d5e-ce29527d25c3/images/2cbe092d16227847842c790b219352cab941f49add2c8e10ff011703545a1852.jpeg',
  ch4: 'https://static.prod-images.emergentagent.com/jobs/c292cde0-62e6-4d67-8d5e-ce29527d25c3/images/7f80a0b8a158eea29a552209dd201c1648fce9d3c8b86797556b2d119d4e47bb.jpeg',
  ch5: 'https://static.prod-images.emergentagent.com/jobs/c292cde0-62e6-4d67-8d5e-ce29527d25c3/images/0eb8cc511b3a50710a5e38e76be0012e87a4fc567f2733b4879f3ee61fd894c9.jpeg',
};

export const MPD_PARCOURS = [
  { id: 'A', title: 'Je découvre le deux-roues', desc: 'Équipement, prise en main, commandes, vérifications, équilibre, regard, freinage, trajectoires et premières situations de circulation.', to: '/mon-premier-depart/deux-roues/je-m-equipe', ready: true, accent: 'orange' },
  { id: 'B', title: 'Je découvre la voiturette', desc: 'Installation, ceinture de sécurité, siège, rétroviseurs, commandes, tableau de bord, contrôles extérieurs, visibilité et maîtrise du véhicule.', to: '/mon-premier-depart/voiturette/je-m-installe', ready: true, accent: 'blue' },
  { id: 'C', title: 'Je comprends la route', desc: 'Observation, anticipation, distances de sécurité, intersections, virages, partage de la chaussée, météo et comportements à risque.', to: '/mon-premier-depart/socle/je-comprends-la-route', ready: true, accent: 'green' },
];

export const MPD_PARCOURS_TAGS = {
  'socle': 'commun',
  'deux-roues': 'deux-roues',
  'voiturette': 'voiturette',
  'scenarios': 'commun-variantes',
  'manoeuvres': 'voiturette',
  'vitesse-freinage': 'commun',
  'usagers-vulnerables': 'commun',
  'conditions-difficiles': 'commun-variantes',
  'panneaux-marquages': 'commun',
  'controles-avant-depart': 'commun-variantes',
  'angles-morts-observation': 'commun-variantes',
  'distances-anticipation': 'commun-variantes',
  'intersections-priorites': 'commun-variantes',
  'changements-direction': 'commun-variantes',
  'stationnement-manoeuvres': 'commun-variantes',
  'comportements-risque': 'commun',
  'mauvais-temps-urgences': 'commun-variantes',
};

export const MPD_REFS = {
  'socle': ['controles-avant-depart', 'angles-morts-observation'],
  'deux-roues': ['controles-avant-depart', 'mauvais-temps-urgences'],
  'voiturette': ['controles-avant-depart', 'intersections-priorites'],
  'scenarios': ['intersections-priorites', 'angles-morts-observation'],
  'manoeuvres': ['stationnement-manoeuvres', 'angles-morts-observation'],
  'vitesse-freinage': ['distances-anticipation', 'mauvais-temps-urgences'],
  'usagers-vulnerables': ['angles-morts-observation', 'changements-direction'],
  'conditions-difficiles': ['mauvais-temps-urgences', 'distances-anticipation'],
  'panneaux-marquages': ['intersections-priorites'],
  'controles-avant-depart': ['deux-roues', 'voiturette'],
  'angles-morts-observation': ['scenarios', 'changements-direction'],
  'distances-anticipation': ['vitesse-freinage', 'mauvais-temps-urgences'],
  'intersections-priorites': ['scenarios', 'panneaux-marquages'],
  'changements-direction': ['angles-morts-observation', 'intersections-priorites'],
  'stationnement-manoeuvres': ['manoeuvres', 'angles-morts-observation'],
  'comportements-risque': ['mauvais-temps-urgences'],
  'mauvais-temps-urgences': ['conditions-difficiles', 'distances-anticipation'],
};

export const MPD_INTRO = {
  presentation: [
    "Mon premier départ est un parcours pédagogique destiné aux adolescents qui s'apprêtent à découvrir la conduite d'un véhicule motorisé à deux ou quatre roues.",
    "L'objectif est de leur donner des repères simples avant, pendant et après leurs premières séances de formation. Le livret doit les aider à comprendre leur véhicule, adopter les bons réflexes de sécurité et mieux appréhender les situations qu'ils rencontreront sur la route.",
    "Il ne s'agit pas de remplacer la formation pratique avec un enseignant. Le livret la prépare, la complète et permet de revenir sur les notions abordées en séance.",
  ],
  promesse: "Comprendre avant d'agir, observer avant de se déplacer et apprendre à partager la route.",
  publics: [
    'aux adolescents qui découvrent le deux-roues motorisé',
    'aux jeunes qui se préparent à conduire une voiturette relevant de la catégorie adaptée',
    'aux élèves qui souhaitent réviser les notions abordées avec leur enseignant',
    'aux parents qui souhaitent accompagner leur enfant dans sa découverte de la sécurité routière',
    'aux enseignants de la conduite qui souhaitent disposer d\'un support complémentaire',
  ],
  objectifs: [
    'identifier les principaux éléments de son véhicule',
    'comprendre le rôle des commandes essentielles',
    'reconnaître les équipements nécessaires à sa sécurité',
    'effectuer des vérifications simples avant le départ',
    'expliquer pourquoi la visibilité et l\'observation sont essentielles',
    'comprendre les notions de réaction, de freinage et de distance d\'arrêt',
    'repérer les principaux risques liés aux intersections et aux changements de direction',
    'identifier les comportements qui favorisent une conduite prudente',
    'expliquer les limites de ses compétences et savoir demander de l\'aide',
  ],
  methode: [
    { step: 'JE DÉCOUVRE', desc: 'Une explication courte, une illustration et les points essentiels à retenir.' },
    { step: "JE M'ENTRAÎNE", desc: 'Un quiz, une situation concrète, une image à analyser ou une checklist à compléter.' },
    { step: 'JE FAIS LE BILAN', desc: 'Un résumé des acquis, les notions à revoir et, lorsque cela est pertinent, une validation par l\'enseignant.' },
  ],
  regles: [
    "Ce livret est un support pédagogique complémentaire. Il ne constitue ni un permis de conduire, ni une autorisation de circuler, ni une validation officielle de compétences.",
    "L'accès à la conduite dépend notamment de l'âge, de la catégorie du véhicule, du titre de conduite requis et des conditions réglementaires applicables.",
    "Les exercices réalisés en ligne ne remplacent jamais les explications de l'enseignant ni les exercices pratiques encadrés.",
  ],
};

const DOSSIER_01 = {
  id: 'socle',
  num: 'Dossier 01',
  title: 'Le socle du livret',
  desc: 'Préparation, découverte du véhicule, vérifications avant le départ et compréhension de la route.',
  chapters: [
    {
      slug: 'avant-de-partir',
      num: 'Chapitre 1',
      title: 'Avant de partir, je me prépare',
      image: IMG.ch1,
      sections: [
        {
          title: '1.1. La conduite commence avant le démarrage',
          blocks: [
            { t: 'p', text: "Prendre le guidon ou s'installer au volant ne suffit pas pour être prêt à conduire. Avant chaque départ, je dois me poser trois questions :" },
            { t: 'olist', items: ['Suis-je correctement équipé et en état de conduire ?', 'Mon véhicule semble-t-il en bon état de fonctionnement ?', "Ai-je compris ce que je vais faire et les consignes données par mon enseignant ?"] },
            { t: 'p', text: "La sécurité commence par cette préparation. Quelques instants de vérification permettent de repérer un problème avant qu'il ne devienne dangereux." },
            { t: 'callout', kind: 'retenir', text: "Si quelque chose me paraît anormal, je ne pars pas sans en parler à mon enseignant ou à la personne responsable du véhicule." },
          ],
        },
        {
          title: '1.2. Mon état physique et mental',
          blocks: [
            { t: 'p', text: 'Pour conduire, je dois être suffisamment attentif, disponible et capable de réagir.' },
            { t: 'p', text: 'La fatigue, le manque de sommeil, le stress important, certaines maladies et les médicaments qui diminuent la vigilance peuvent modifier mes capacités.' },
            { t: 'p', text: "Je dois également éviter toute distraction. Un téléphone, une conversation qui m'absorbe ou une musique trop forte peuvent détourner mon attention de la circulation. Avant une séance, je préviens mon enseignant si je ne me sens pas en état de conduire." },
            { t: 'callout', kind: 'question', text: 'Suis-je réellement disponible pour observer, comprendre et réagir ?' },
          ],
        },
        {
          title: '1.3. Je connais mes limites',
          blocks: [
            { t: 'p', text: "Apprendre à conduire, c'est aussi accepter de ne pas tout savoir. Je peux avoir besoin de plusieurs essais pour comprendre une commande, réaliser une manœuvre ou anticiper une situation." },
            { t: 'p', text: "Je ne dois pas chercher à impressionner les autres, à aller plus vite que mes capacités ou à reproduire un comportement vu sur les réseaux sociaux." },
            { t: 'p', text: 'Je peux demander une nouvelle explication. Je peux demander une démonstration. Je peux également signaler que je ne me sens pas prêt à réaliser un exercice.' },
            { t: 'callout', kind: 'retenir', title: 'La bonne attitude', text: 'Progresser à mon rythme, sans brûler les étapes.' },
          ],
        },
        {
          title: '1.4. Mon équipement pour le deux-roues',
          blocks: [
            { t: 'p', text: "L'équipement protège le corps en cas de chute, limite certaines blessures et améliore parfois le confort et la visibilité." },
            { t: 'p', text: "Pour les séquences pratiques de la formation à la catégorie AM, l'équipement réglementaire comprend notamment un casque homologué, des gants adaptés, un blouson ou une veste à manches longues, un pantalon ou une combinaison, ainsi que des bottes ou chaussures montantes conformes aux exigences applicables." },
            { t: 'p', text: 'Pour la pratique au quotidien, je privilégie également :' },
            { t: 'list', items: ['des vêtements résistants et adaptés à la météo', 'des chaussures qui maintiennent correctement les pieds', 'des équipements à la bonne taille', 'des éléments visibles lorsque les conditions le nécessitent'] },
            { t: 'p', text: "Un équipement ne doit pas gêner les mouvements, empêcher de tourner la tête ou compliquer l'utilisation des commandes." },
            { t: 'callout', kind: 'savais', text: "Un casque mal ajusté peut bouger ou ne pas protéger correctement. Il doit être adapté à la morphologie, correctement attaché et en bon état." },
          ],
        },
        {
          title: "1.5. Dans la voiturette : je m'installe correctement",
          blocks: [
            { t: 'p', text: "Dans un quadricycle léger à moteur, l'habitacle ne dispense pas d'une préparation sérieuse. Avant de démarrer :" },
            { t: 'list', items: ["je m'installe au fond du siège", "je règle ma position afin d'atteindre les commandes sans difficulté", "j'attache ma ceinture de sécurité", 'je règle les rétroviseurs', 'je vérifie que les vitres et le pare-brise permettent une vision suffisante', 'je repère les commandes essentielles', 'je vérifie que les objets transportés ne risquent pas de gêner les pédales ou de se déplacer'] },
            { t: 'p', text: 'Je ne démarre pas tant que ma position ne me permet pas de commander le véhicule avec précision.' },
            { t: 'callout', kind: 'retenir', text: "Une bonne installation facilite le contrôle du véhicule et améliore la qualité de l'observation." },
          ],
        },
      ],
    },
    {
      slug: 'je-decouvre-mon-vehicule',
      num: 'Chapitre 2',
      title: 'Je découvre mon véhicule',
      image: IMG.ch2,
      sections: [
        {
          title: '2.1. Pourquoi connaître son véhicule ?',
          blocks: [
            { t: 'p', text: "Avant de conduire, je dois savoir où se trouvent les commandes, à quoi elles servent et comment les utiliser." },
            { t: 'p', text: "Je ne dois pas découvrir une commande au hasard pendant que je circule. La prise en main se réalise dans un environnement adapté, avec les explications de l'enseignant." },
            { t: 'p', text: 'Chaque véhicule peut présenter des différences. Je dois donc toujours me familiariser avec le modèle utilisé pendant la séance.' },
          ],
        },
        {
          title: "2.2. Les commandes principales d'un deux-roues",
          blocks: [
            { t: 'p', text: 'Selon le modèle, je dois repérer :' },
            { t: 'list', items: ["la commande d'accélération", 'les leviers de frein', 'les commandes des clignotants', "l'avertisseur sonore", 'la commande des feux', 'le contact ou le système de mise en marche', 'les témoins du tableau de bord', 'les commandes propres au modèle utilisé'] },
            { t: 'p', text: "Le rôle et la disposition de certaines commandes peuvent varier. Je demande confirmation à l'enseignant avant la mise en mouvement." },
            { t: 'sub', text: "La poignée d'accélération" },
            { t: 'p', text: "Elle permet de commander l'accélération du véhicule selon son fonctionnement. Je dois apprendre à l'utiliser progressivement, sans geste brusque. Une action trop importante peut provoquer une accélération inattendue et perturber mon équilibre." },
            { t: 'sub', text: 'Les freins' },
            { t: 'p', text: "Le véhicule peut disposer de commandes de frein distinctes. Leur fonctionnement dépend du type de deux-roues. Je dois repérer chaque commande, comprendre son action et apprendre à freiner progressivement dans les conditions définies par l'enseignant." },
            { t: 'p', text: "Je ne dois pas improviser une technique de freinage à partir d'une vidéo ou d'un conseil non vérifié." },
            { t: 'sub', text: 'Les clignotants' },
            { t: 'p', text: "Ils permettent d'indiquer mon intention aux autres usagers. Ils ne me donnent jamais la priorité. Avant de changer de direction, je dois observer, vérifier que la manœuvre est possible, signaler mon intention et agir sans mettre les autres en danger." },
          ],
        },
        {
          title: "2.3. Les commandes principales d'une voiturette",
          blocks: [
            { t: 'p', text: 'Selon le modèle, je dois identifier :' },
            { t: 'list', items: ['le volant', "les pédales d'accélération et de freinage", 'le sélecteur de marche', 'les commandes des clignotants', 'les feux', "l'avertisseur sonore", 'les essuie-glaces et le lave-glace', 'le frein de stationnement', 'les témoins du tableau de bord', 'les commandes de chauffage ou de désembuage'] },
            { t: 'p', text: 'Je repère les commandes moteur arrêté lorsque cela est possible et sans effectuer de manipulation interdite par le constructeur.' },
            { t: 'sub', text: 'Le volant' },
            { t: 'p', text: 'Il me permet de commander la direction du véhicule. Je dois adopter une position qui me permet de tourner le volant sans être gêné par le siège, la ceinture ou mes vêtements.' },
            { t: 'sub', text: 'Les pédales' },
            { t: 'p', text: "Je dois identifier clairement la pédale de frein et celle d'accélération. Je garde les pieds dans une position qui me permet d'agir sans hésitation. Je ne place aucun objet susceptible de se glisser sous les pédales." },
            { t: 'sub', text: 'Le sélecteur de marche' },
            { t: 'p', text: "Il permet de choisir un mode de fonctionnement selon le véhicule. La procédure de sélection doit respecter les indications du constructeur et les consignes de l'enseignant. Je ne change pas de mode sans avoir compris les conditions nécessaires." },
          ],
        },
        {
          title: '2.4. Je découvre le tableau de bord',
          blocks: [
            { t: 'p', text: "Le tableau de bord fournit des informations sur le fonctionnement du véhicule. Certains témoins signalent une fonction activée. D'autres indiquent un défaut ou une situation nécessitant une vérification. La signification exacte dépend du véhicule et de son manuel d'utilisation." },
            { t: 'p', text: 'Je dois apprendre à :' },
            { t: 'list', items: ['reconnaître les principaux témoins', "distinguer une information normale d'une alerte", "comprendre qu'un voyant rouge ou une alerte importante ne doit pas être ignoré", "arrêter la conduite dans des conditions sûres et demander de l'aide si une anomalie le justifie"] },
            { t: 'callout', kind: 'attention', text: "Je ne suppose jamais qu'un voyant est sans importance parce que le véhicule semble continuer à fonctionner." },
          ],
        },
      ],
    },
    {
      slug: 'je-verifie-avant-de-partir',
      num: 'Chapitre 3',
      title: 'Je vérifie avant de partir',
      image: IMG.ch3,
      sections: [
        {
          title: '3.1. Pourquoi contrôler son véhicule ?',
          blocks: [
            { t: 'p', text: "Un véhicule peut présenter un défaut visible avant même de démarrer : un pneu endommagé, un feu qui ne fonctionne pas, une fuite ou un élément mal fixé." },
            { t: 'p', text: "Le contrôle préalable permet de repérer certaines anomalies et de décider si le véhicule peut être utilisé. Ces vérifications ne remplacent pas l'entretien réalisé par un professionnel." },
          ],
        },
        {
          title: '3.2. Le contrôle extérieur',
          blocks: [
            { t: 'p', text: 'Avant de partir, je regarde le véhicule et son environnement. Je vérifie notamment :' },
            { t: 'list', items: ["l'absence d'obstacle immédiat autour du véhicule", "l'état apparent des pneus", "l'absence de dommage évident", "l'état apparent des feux et des dispositifs de signalisation", "la présence d'éléments mal fixés", "l'absence de fuite visible anormale"] },
            { t: 'p', text: "Sur un deux-roues, je porte une attention particulière aux commandes, aux leviers, aux rétroviseurs et aux éléments susceptibles d'affecter la stabilité ou le freinage." },
            { t: 'p', text: "Sur une voiturette, je vérifie également que les vitres permettent une bonne visibilité et que rien ne gêne les roues, les pédales ou les ouvrants." },
          ],
        },
        {
          title: '3.3. Les pneumatiques',
          blocks: [
            { t: 'p', text: 'Les pneus sont le seul point de contact entre le véhicule et la chaussée. Ils contribuent à la tenue de route, au freinage et à la stabilité.' },
            { t: 'p', text: 'Je vérifie visuellement :' },
            { t: 'list', items: ["qu'aucun pneu ne semble dégonflé", "qu'il n'y a pas de coupure, hernie ou déformation visible", "qu'aucun objet suspect ne semble être planté dans la bande de roulement", "que l'usure ne paraît pas anormale"] },
            { t: 'p', text: "La pression doit être contrôlée selon les préconisations du constructeur, avec une mesure adaptée. L'aspect visuel ne suffit pas pour confirmer une pression correcte." },
            { t: 'callout', kind: 'attention', title: 'Si je constate une anomalie', text: 'Je la signale avant de prendre la route. Je ne tente pas une réparation improvisée.' },
          ],
        },
        {
          title: '3.4. Les feux et les dispositifs de signalisation',
          blocks: [
            { t: 'p', text: "Les feux permettent notamment de voir, d'être vu et de signaler certaines intentions. Je vérifie leur état apparent et leur fonctionnement selon la procédure prévue pour le véhicule." },
            { t: 'p', text: 'Les principaux éléments à connaître sont :' },
            { t: 'list', items: ['les feux de position', 'les feux de croisement', "les feux de route, lorsqu'ils existent", 'les feux stop', 'les indicateurs de direction', 'les feux de détresse', 'les dispositifs réfléchissants'] },
            { t: 'p', text: "La vérification du fonctionnement des feux peut nécessiter l'aide d'une autre personne." },
          ],
        },
        {
          title: '3.5. Les commandes de freinage',
          blocks: [
            { t: 'p', text: "Je repère les commandes et vérifie visuellement qu'elles ne présentent pas de dommage apparent. Les contrôles fonctionnels doivent être effectués dans les conditions adaptées, selon les instructions de l'enseignant et du constructeur." },
            { t: 'p', text: "Si une commande paraît anormale, si un témoin signale un problème ou si le freinage semble insuffisant, le véhicule ne doit pas être utilisé avant vérification." },
          ],
        },
        {
          title: '3.6. Les alertes au tableau de bord',
          blocks: [
            { t: 'p', text: "Je mets le contact selon la procédure du constructeur et j'observe les témoins. Je ne cherche pas à mémoriser une liste universelle de voyants : leur représentation et leur signification peuvent varier selon le modèle." },
            { t: 'p', text: "Je consulte le manuel du véhicule et demande à l'enseignant de m'expliquer les alertes importantes." },
          ],
        },
      ],
      checklist: {
        title: 'Ma checklist avant le départ',
        goal: "Ne pas partir sans avoir identifié les anomalies apparentes et sans avoir reçu les consignes nécessaires.",
        items: [
          'Je suis correctement équipé ou installé.',
          'Je connais les commandes essentielles.',
          "Je vérifie l'environnement immédiat.",
          "Je regarde l'état apparent des pneus.",
          'Je vérifie les feux et les dispositifs de signalisation.',
          'Je repère toute anomalie visible.',
          'Je prends connaissance des alertes du tableau de bord.',
          'Je signale toute anomalie avant de partir.',
          "J'écoute les consignes de l'enseignant.",
        ],
      },
    },
    {
      slug: 'je-comprends-la-route',
      num: 'Chapitre 4',
      title: 'Je comprends ce qui se passe sur la route',
      image: IMG.ch4,
      sections: [
        {
          title: "4.1. Voir n'est pas toujours percevoir",
          blocks: [
            { t: 'p', text: "La conduite exige de regarder, de comprendre ce que l'on observe et d'anticiper ce qui peut se produire. Je peux regarder un rétroviseur sans remarquer un véhicule. Je peux voir un piéton sans comprendre qu'il s'apprête à traverser. L'observation doit donc être active." },
            { t: 'p', text: 'Je cherche les indices qui peuvent annoncer un danger :' },
            { t: 'list', items: ['un véhicule qui ralentit', "une portière susceptible de s'ouvrir", 'un piéton proche du bord de la chaussée', 'un cycliste qui se décale', "un véhicule qui approche d'une intersection", 'un obstacle qui réduit la visibilité', 'une chaussée humide ou dégradée'] },
          ],
        },
        {
          title: '4.2. Je garde une marge de sécurité',
          blocks: [
            { t: 'p', text: "Je ne dois pas conduire en comptant sur le fait que les autres usagers réagiront toujours correctement. Je conserve une marge pour pouvoir réagir à un événement imprévu." },
            { t: 'p', text: 'Cette marge dépend notamment :' },
            { t: 'list', items: ['de ma vitesse', 'de la distance avec les autres usagers', 'de la visibilité', "de l'adhérence", "de l'état de la chaussée", "de mon niveau d'expérience", 'de la situation rencontrée'] },
            { t: 'p', text: 'Plus la situation est incertaine, plus je dois être prudent et adapter mon comportement.' },
          ],
        },
        {
          title: '4.3. Le temps de réaction',
          blocks: [
            { t: 'p', text: "Le temps de réaction correspond au temps qui s'écoule entre la perception d'un événement et le début de la réaction du conducteur. Pendant ce délai, le véhicule continue d'avancer. La distance parcourue pendant le temps de réaction augmente avec la vitesse." },
            { t: 'p', text: "Par exemple, à 45 km/h, un véhicule parcourt environ 12,5 mètres en une seconde. Cela signifie qu'une seconde d'inattention peut représenter une distance importante avant même le début du freinage." },
            { t: 'p', text: "Cette valeur est un ordre de grandeur pédagogique, et non une mesure du temps de réaction de chaque conducteur." },
          ],
        },
        {
          title: '4.4. La distance de freinage',
          blocks: [
            { t: 'p', text: "La distance de freinage correspond à la distance parcourue entre le début de l'action de freinage et l'arrêt du véhicule. Elle varie notamment selon :" },
            { t: 'list', items: ['la vitesse', "l'adhérence", "l'état des pneus", "l'état du système de freinage", 'la pente', 'les caractéristiques du véhicule'] },
            { t: 'p', text: 'Sur une chaussée humide, glissante ou dégradée, la distance de freinage peut augmenter.' },
          ],
        },
        {
          title: "4.5. La distance d'arrêt",
          blocks: [
            { t: 'p', text: "La distance d'arrêt comprend la distance parcourue pendant le temps de réaction et la distance de freinage." },
            { t: 'formula', text: "Distance d'arrêt = distance de réaction + distance de freinage" },
            { t: 'p', text: "Je dois comprendre qu'un véhicule ne s'arrête pas instantanément lorsqu'un danger apparaît. Je ne dois jamais choisir ma vitesse uniquement en fonction de la vitesse maximale autorisée. Je dois aussi tenir compte de ce que je peux voir, comprendre et maîtriser." },
          ],
        },
        {
          title: '4.6. Les intersections',
          blocks: [
            { t: 'p', text: "Une intersection est une zone où plusieurs courants de circulation peuvent se croiser. Avant de m'engager, je dois :" },
            { t: 'list', items: ["observer l'environnement", 'identifier les règles de priorité applicables', "repérer les usagers présents ou susceptibles d'arriver", 'adapter mon allure', "vérifier que je peux m'engager sans créer de danger", 'poursuivre ma surveillance pendant la manœuvre'] },
            { t: 'p', text: "Je ne m'engage pas uniquement parce que le véhicule devant moi avance." },
          ],
        },
        {
          title: '4.7. Les virages',
          blocks: [
            { t: 'p', text: "Dans un virage, je dois adapter mon allure à la visibilité, à la chaussée et à la courbure. Je cherche à comprendre ce qui peut se trouver au-delà de la partie visible : véhicule arrêté, obstacle, gravillons, chaussée humide ou usager vulnérable." },
            { t: 'p', text: "Sur un deux-roues, le regard et l'équilibre jouent un rôle essentiel. Sur une voiturette, la trajectoire et la vitesse doivent également être adaptées." },
            { t: 'p', text: 'Les techniques pratiques sont enseignées et travaillées avec un professionnel, dans un environnement adapté.' },
          ],
        },
        {
          title: '4.8. La route se partage',
          blocks: [
            { t: 'p', text: "Je ne suis pas seul sur la route. Je dois tenir compte des piétons, cyclistes, autres deux-roues, véhicules, transports collectifs et véhicules de secours." },
            { t: 'p', text: "Un usager vulnérable peut être difficile à voir, notamment dans un angle mort, derrière un obstacle ou dans une zone peu éclairée." },
            { t: 'p', text: 'Je garde une attitude prévisible, je signale mes intentions lorsque nécessaire et je respecte les règles de circulation.' },
          ],
        },
      ],
    },
    {
      slug: 'je-fais-le-point',
      num: 'Chapitre 5',
      title: 'Je fais le point',
      image: IMG.ch5,
      sections: [
        {
          title: '5.1. Ce que je dois retenir',
          blocks: [
            { t: 'list', items: [
              "Avant de conduire, je prépare mon équipement, mon installation et mon véhicule.",
              'Je dois connaître les commandes essentielles et comprendre les informations importantes du tableau de bord.',
              "Je vérifie l'état apparent du véhicule et je signale les anomalies.",
              "Sur la route, je regarde loin, j'observe les autres usagers, j'anticipe et j'adapte mon comportement.",
              'Je ne confonds jamais vitesse autorisée et vitesse adaptée.',
              "Je peux demander de l'aide lorsque je ne comprends pas une situation.",
            ] },
          ],
        },
      ],
      quiz: {
        title: 'Quiz de fin de parcours',
        questions: [
          { q: 'Avant le départ, que dois-je faire ?', options: ['Démarrer immédiatement pour gagner du temps.', "Vérifier mon installation, les commandes et l'état apparent du véhicule.", 'Vérifier uniquement le niveau de carburant.'], answer: 1, explain: 'La préparation permet de repérer les anomalies et de se familiariser avec le véhicule.' },
          { q: 'À quoi servent les clignotants ?', options: ['À obtenir la priorité.', 'À signaler une intention aux autres usagers.', 'À prouver que la manœuvre est sans danger.'], answer: 1, explain: 'Le clignotant informe les autres usagers, mais ne donne aucune priorité.' },
          { q: "Qu'est-ce que la distance d'arrêt ?", options: ['La distance parcourue pendant le freinage uniquement.', 'La distance parcourue pendant le temps de réaction et le freinage.', "La distance entre deux véhicules à l'arrêt."], answer: 1, explain: "La distance d'arrêt comprend la distance de réaction et la distance de freinage." },
          { q: 'Que faire si un témoin indique une anomalie importante ?', options: ['Continuer sans vérifier.', "Ignorer le témoin s'il disparaît parfois.", "Comprendre l'alerte et demander une vérification adaptée."], answer: 2, explain: 'Une alerte importante doit être comprise et traitée.' },
          { q: 'Pourquoi adapter sa vitesse ?', options: ['Pour rester capable de réagir dans la situation rencontrée.', 'Uniquement pour éviter les contraventions.', 'Pour suivre la vitesse des autres usagers.'], answer: 0, explain: 'La vitesse doit être adaptée à la situation et aux conditions de circulation.' },
          { q: 'Que faire si je ne me sens pas prêt à effectuer un exercice ?', options: ['Essayer seul pour ne pas perdre de temps.', 'Le signaler à mon enseignant et demander des explications.', 'Accélérer pour terminer plus rapidement.'], answer: 1, explain: "Demander de l'aide fait partie de l'apprentissage." },
        ],
      },
      bilan: {
        title: 'Mon bilan personnel',
        intro: 'À la fin de ce premier parcours, je peux me poser les questions suivantes :',
        items: [
          'Je sais expliquer pourquoi la préparation est importante.',
          'Je sais repérer les commandes essentielles de mon véhicule.',
          'Je sais identifier plusieurs anomalies apparentes.',
          'Je comprends la différence entre distance de réaction et distance de freinage.',
          "Je sais expliquer pourquoi l'observation et l'anticipation sont indispensables.",
          "Je sais demander de l'aide si je ne comprends pas une situation.",
        ],
        next: "Approfondir les notions propres à mon véhicule et les mettre en pratique avec mon enseignant.",
      },
    },
  ],
};

export const MPD_DOSSIERS = [DOSSIER_01, DOSSIER_02, DOSSIER_03, DOSSIER_04, DOSSIER_05, DOSSIER_06, DOSSIER_07, DOSSIER_08, DOSSIER_09, DOSSIER_10, DOSSIER_11, DOSSIER_12, DOSSIER_13, DOSSIER_14, DOSSIER_15, DOSSIER_16, DOSSIER_17];

export const MPD_MENTIONS = [
  "Contenu pédagogique original destiné à être intégré à CodeVoiture.fr et à être décliné, selon les chapitres, pour Code2Roues.fr.",
  "Les textes doivent être relus avant publication pour vérifier leur conformité à la réglementation en vigueur, aux catégories de véhicules concernées et aux consignes des formations applicables. Les illustrations sont originales.",
  "Ce support ne remplace pas les textes réglementaires, le manuel du constructeur ni la formation pratique encadrée.",
];

export function getChapter(dossierId, slug) {
  const dossier = MPD_DOSSIERS.find((d) => d.id === dossierId);
  if (!dossier) return null;
  const idx = dossier.chapters.findIndex((c) => c.slug === slug);
  if (idx === -1) return null;
  return { dossier, chapter: dossier.chapters[idx], prev: dossier.chapters[idx - 1] || null, next: dossier.chapters[idx + 1] || null, index: idx };
}
